import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import find from 'lodash/find';
import { connect } from 'react-redux';
import unionBy from 'lodash/unionBy';
import differenceBy from 'lodash/differenceBy';
import MarketLocationSelector from 'components/MarketLocationSelector';
import H1 from 'components/deprecated/legacyElements/H1';
import { update } from 'actions/onboarding';
import { analyticsEvents, eventCategories, track } from 'util/analytics';
import styles from './style.module.scss';

export class LocationPage extends PureComponent {
  static propTypes = {
    update: PropTypes.func.isRequired,
    areasOfInterest: PropTypes.arrayOf(PropTypes.object).isRequired,
  };

  get selectedSubmarkets() {
    return this.props.areasOfInterest.filter(
      (area) => area.__typename === 'Submarket'
    );
  }

  get selectedNeighborhoods() {
    return this.props.areasOfInterest.filter(
      (area) => area.__typename === 'Neighborhood'
    );
  }

  get selectedMarket() {
    return find(this.props.areasOfInterest, { __typename: 'Market' });
  }

  onMarketChange = ({ cities, ...market }) => {
    track(analyticsEvents.geolocate, {
      category: eventCategories.user_change_location,
      label: `location change from ${this.selectedMarket.name} to ${market.name}`,
    });
    this.props.update({
      areasOfInterest: [market],
      // follow two arguments are to fit a mutli submarket/city selector with a single city mutation.
      // This is a patch agreed with Hayley.
      city: cities[0]?.name || market.name,
      state: cities[0]?.state,
    });
  };

  onNeighborhoodChange = (nhood, checked) => {
    let areasOfInterest = [...this.props.areasOfInterest];
    if (checked) {
      // add neighborhood to areas of interest
      areasOfInterest = [...areasOfInterest, nhood];
    } else {
      const neighborhoodsSubmarket = this.selectedSubmarkets.filter(
        ({ neighborhoods: nhoods }) => nhoods.some((n) => n.id === nhood.id)
      );
      if (neighborhoodsSubmarket.length > 0) {
        // deselecting a nhood from a selected submarket
        // if code gets here neighborhoodsSubmarket will always be 1
        const newNeighborhoods = neighborhoodsSubmarket[0].neighborhoods
          .filter((n) => n.id !== nhood.id)
          .filter(({ visibility }) => visibility === 'VISIBLE');
        areasOfInterest = differenceBy(
          areasOfInterest,
          neighborhoodsSubmarket,
          'externalId'
        );
        areasOfInterest = [...areasOfInterest, ...newNeighborhoods];
      } else {
        // deselect neighborhood
        areasOfInterest = areasOfInterest.filter(
          (area) => area.externalId !== nhood.externalId
        );
      }
    }

    this.props.update({
      areasOfInterest,
    });
  };

  onSubmarketChange = (submarket, checked) => {
    const arrayHandlerMethod = checked ? unionBy : differenceBy;
    let areasOfInterest = [...this.props.areasOfInterest];
    if (checked)
      areasOfInterest = differenceBy(
        this.props.areasOfInterest,
        submarket.neighborhoods.filter(
          ({ visibility }) => visibility === 'VISIBLE'
        ),
        'externalId'
      );

    areasOfInterest = arrayHandlerMethod(
      areasOfInterest,
      [submarket],
      'externalId'
    );

    this.props.update({
      areasOfInterest,
    });
  };

  render() {
    return (
      <div>
        <H1>Choose a location.</H1>
        <p>
          Choose the city where your company is located to find the best
          location for your office.
        </p>
        <div className={styles.locationSelectorContainer}>
          <MarketLocationSelector
            selectedMarket={this.selectedMarket}
            selectedNeighborhoods={this.selectedNeighborhoods}
            onMarketChange={this.onMarketChange}
            onNeighborhoodChange={this.onNeighborhoodChange}
            onSubmarketChange={this.onSubmarketChange}
            selectedSubmarkets={this.selectedSubmarkets}
            additionalMapOptions={{
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              fullscreenControl: false,
            }}
          />
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    areasOfInterest: state.onboarding.areasOfInterest,
  }),
  {
    update,
  }
)(LocationPage);
